module.exports = __webpack_public_path__ + "img/mg-pop.99c16cd3.png";